module.exports = __webpack_public_path__ + "static/banner-services-mobile-6b230dd5d0b52371c12cd7dfe1d2552e.jpg";